"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HTML_1 = require("./components/HTML");
var MyPage_1 = require("./components/MyPage");
var Booking_1 = require("./components/Booking");
var Form_1 = require("./components/Form");
var globalComponents = [HTML_1.default, MyPage_1.default, Booking_1.default, Form_1.default];
exports.default = globalComponents;
//# sourceMappingURL=index.js.map